module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Lupsingen-8fce1758c8a60e80205971a1ebb0d899.png";